import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { CommonComponentsModule } from "../common/common-components.module";
import { CareLocationTypeComponent } from "./care-location-type/care-location-type";
import { CareLocationComponent } from "./care-location/care-location";
import { VerificationComponent } from "./checkbox/checkbox";
import { CurrentDiagnosisComponent } from "./current-diagnosis/current-diagnosis";
import { DatePickerComponent } from "./date-picker/date-picker";
import { OrderingSearchInputComponent } from "./diagnosis-search/diagnosis-search";
import { DisciplineComponent } from "./discipline/discipline";
import { OrderingDropdownComponent } from "./dropdown/dropdown";
import { FileUploadComponent } from "./file-upload/file-upload";
import { LevelOfCareComponent } from "./level-of-care/level-of-care";
import { MARDetailsComponent } from "./mar-details/mar-details";
import { MedicationIngredientsScriptsureComponent } from "./medication-ingredients-scriptsure/medication-ingredients-scriptsure";
import { MedicationNameDescriptionScriptSureComponent } from "./medication-name-description-scriptsure/medication-name-description-scriptsure";
import { MedicationStrengthSelectorScripsureComponent } from "./medication-strength-selector-scriptsure/medication-strength-selector-scriptsure";
import { MultiOptionComponent } from "./multi-option/multi-option";
import { OrderTypeComponent } from "./order-type/order-type";
import { OrderingProviderComponent } from "./ordering-provider/ordering-provider";
import { PatientLocationComponent } from "./patient-location/patient-location";
import { Quantity } from "./quantity/quantity";
import { RadioGroupComponent } from "./radio-group/radio-group";
import { ReasonForRespiteComponent } from "./reason-for-respite/reason-for-respite";
import { ReasonsForGIPComponent } from "./reasons-for-gip/reasons-for-gip";
import { ProviderNotesComponent } from "./text-area/text-area";
import { OrderTextFieldComponent } from "./text-field/text-field";
import { VisitFrequencyDescription } from "./visit-frequency-description/visit-frequency-description";

@NgModule({
  declarations: [
    OrderTypeComponent,
    MultiOptionComponent,
    OrderingProviderComponent,
    MedicationIngredientsScriptsureComponent,
    OrderingDropdownComponent,
    OrderTextFieldComponent,
    DatePickerComponent,
    ProviderNotesComponent,
    RadioGroupComponent,
    VerificationComponent,
    FileUploadComponent,
    OrderingSearchInputComponent,
    CurrentDiagnosisComponent,
    LevelOfCareComponent,
    CareLocationTypeComponent,
    CareLocationComponent,
    ReasonForRespiteComponent,
    PatientLocationComponent,
    ReasonsForGIPComponent,
    MedicationStrengthSelectorScripsureComponent,
    MedicationNameDescriptionScriptSureComponent,
    Quantity,
    VisitFrequencyDescription,
    MARDetailsComponent,
    DisciplineComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule.forChild(),
    NgSelectModule,
    CommonComponentsModule,
    NgbTimepickerModule,
  ],
  exports: [
    OrderTypeComponent,
    MultiOptionComponent,
    OrderingProviderComponent,
    MedicationIngredientsScriptsureComponent,
    OrderTextFieldComponent,
    DatePickerComponent,
    ProviderNotesComponent,
    RadioGroupComponent,
    VerificationComponent,
    LevelOfCareComponent,
    CareLocationTypeComponent,
    PatientLocationComponent,
    MedicationStrengthSelectorScripsureComponent,
    MedicationNameDescriptionScriptSureComponent,
  ],
  providers: [CommonComponentsModule],
})
export class OrderManagementComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/order-management/order-management.module.ts